import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ContextMenuService {
    public show: Subject<{event: MouseEvent, obj: any[] | undefined}> = new Subject<{event: MouseEvent, obj: any[] | undefined}>();
}
